const demTemplatesTypes = {
  RESET_DEM_TEMPLATE_STATE: 'RESET_DEM_TEMPLATE_STATE',

  SYNC_DEM_TEMPLATES: {
    REQUEST: 'SYNC_DEM_TEMPLATES.REQUEST',
    SUCCESS: 'SYNC_DEM_TEMPLATES.SUCCESS',
    FAILURE: 'SYNC_DEM_TEMPLATES.FAILURE',
  },

  FETCH_DEM_TEMPLATE: {
    REQUEST: 'FETCH_DEM_TEMPLATE.REQUEST',
    SUCCESS: 'FETCH_DEM_TEMPLATE.SUCCESS',
    FAILURE: 'FETCH_DEM_TEMPLATE.FAILURE',
  },

  CREATE_DEM_TEMPLATE: {
    REQUEST: 'CREATE_DEM_TEMPLATE.REQUEST',
    SUCCESS: 'CREATE_DEM_TEMPLATE.SUCCESS',
    FAILURE: 'CREATE_DEM_TEMPLATE.FAILURE',
  },

  UPDATE_DEM_TEMPLATE: {
    REQUEST: 'UPDATE_DEM_TEMPLATE.REQUEST',
    SUCCESS: 'UPDATE_DEM_TEMPLATE.SUCCESS',
    FAILURE: 'UPDATE_DEM_TEMPLATE.FAILURE',
  },

  DUPLICATE_DEM_TEMPLATE: {
    REQUEST: 'DUPLICATE_DEM_TEMPLATE.REQUEST',
    SUCCESS: 'DUPLICATE_DEM_TEMPLATE.SUCCESS',
    FAILURE: 'DUPLICATE_DEM_TEMPLATE.FAILURE',
  },

  ARCHIVE_DEM_TEMPLATE: {
    REQUEST: 'ARCHIVE_DEM_TEMPLATE.REQUEST',
    SUCCESS: 'ARCHIVE_DEM_TEMPLATE.SUCCESS',
    FAILURE: 'ARCHIVE_DEM_TEMPLATE.FAILURE',
  },

  GENERATE_AI_DEM_TEMPLATE: {
    REQUEST: 'GENERATE_AI_DEM_TEMPLATE.REQUEST',
    SUCCESS: 'GENERATE_AI_DEM_TEMPLATE.SUCCESS',
    FAILURE: 'GENERATE_AI_DEM_TEMPLATE.FAILURE',
  },

  TOGGLE_AI_PANEL: 'TOGGLE_AI_PANEL',
  RESET_AI_CONVERSATION: 'RESET_AI_CONVERSATION',
  UNDO_LAST_AI_DESIGN: 'UNDO_LAST_AI_DESIGN',
};

export default demTemplatesTypes;
